<template>
  <div class="mx-auto col-sm-8">
    <div class="row mb-2">
      <div class="form-group col-12">
        <label for="client">{{ $t("client") }}</label>

        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :options="clients"
          :getOptionLabel="(client) => customOptionLabel(client)"
          v-model="clientSelected"
        />
      </div>
    </div>

    <div class="row mb-5" v-if="clientSelected">
      <div class="col-12">
        <button
          :class="[checkHasFrotixPneus() ? 'btn-danger' : 'btn-primary']"
          class="btn"
          @click="setFrotixPneus(checkHasFrotixPneus() ? false : true)"
        >
          {{ checkHasFrotixPneus() ? "Desativar" : "Ativar" }} Frotix Pneus
        </button>
      </div>
    </div>

    <b-alert
      :show="alert.show"
      @dismissed="alert.show = false"
      dismissible
      fade
      :variant="alert.type || 'success'"
    >
      {{ alert.message }}
    </b-alert>
  </div>
</template>

<script>
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import { mapActions, mapState } from "vuex";

const defaulAlert = {
  show: false,
  type: "success",
};

export default {
  name: "TiresComponent",
  components: {
    LoaderButton,
    Combobox,
  },

  data() {
    return {
      clientSelected: undefined,
      alert: defaulAlert,
      timeout: null,
    };
  },

  computed: {
    ...mapState({
      clients: (state) => state.atendimentos.clients,
    }),
  },

  methods: {
    ...mapActions("atendimentos", [
      "fetchClientsFrotixPneus",
      "setStatusFrotixPneus",
    ]),

    async setFrotixPneus() {
      const changed = await this.setStatusFrotixPneus({ client: this.clientSelected })

      this.$store.dispatch(
        "toast/showToast",
        {
          message: `Frotix Pneus ${this.clientSelected.frotix_pneus ? "DESATIVADO" : "ATIVADO"} para ${this.clientSelected.CLI_DSC}`,
          type: changed ? "success" : "error"
        },
        { root: true }
      );

      this.clientSelected = undefined

      await this.fetchClientsFrotixPneus()
    },

    customOptionLabel(client) {
      const { CLI_DSC, frotix_pneus } = client;

      return `${CLI_DSC} (${frotix_pneus ? "SIM" : "NÃO"})`;
    },

    checkHasFrotixPneus() {
      const { frotix_pneus } = this.clientSelected;

      return Boolean(frotix_pneus);
    },
  },

  async mounted() {
    await this.fetchClientsFrotixPneus();
  },
};
</script>
